import React from 'react';
import { Tooltip } from '@mui/material';

const truncateText = (str: string | any[], maxLength: number): React.ReactNode | string | any[] => {
  return str?.length > maxLength ? (
    <Tooltip title={str} arrow>
      <span>{`${str.slice(0, maxLength)}...`}</span>
    </Tooltip>
  ) : (
    str
  );
};

export { truncateText };
export default truncateText;
